import { checkDiff } from '../../../utils/formValidation/errorCheckingFunctions';
import {
    getDateMaxMessage,
    getDateMinMessage,
    getEqualOrLessMessage,
    getEqualOrMoreMessage,
    getNumMaxMessage,
    getReqMessage
} from '../../../utils/formValidation/errorMessageFunctions';

export const NOTES_CHAR_LIMIT = 2000;
export const MAX_HOURS = 48;

export const validate = (newEntry, initialState) => {
    let newErrors = {};

    if (newEntry.minimumHoursPerWeek && newEntry.minimumHoursPerWeek > MAX_HOURS) {
        newErrors = {
            ...newErrors,
            minimumHoursPerWeek: {
                error: true,
                message: getNumMaxMessage('Minimum hours', MAX_HOURS)
            }
        };
    } else if (newEntry.maximumHoursPerWeek && !newEntry.minimumHoursPerWeek) {
        newErrors = {
            ...newErrors,
            minimumHoursPerWeek: {
                error: true,
                message: getReqMessage('If maximum hours are entered, a minimum hours value')
            }
        };
    } else if (
        newEntry.minimumHoursPerWeek &&
        newEntry.maximumHoursPerWeek &&
        newEntry.minimumHoursPerWeek > newEntry.maximumHoursPerWeek
    ) {
        newErrors = {
            ...newErrors,
            minimumHoursPerWeek: {
                error: true,
                message: getEqualOrLessMessage('Minimum hours', 'maximum hours')
            },
            maximumHoursPerWeek: {
                error: true,
                message: getEqualOrMoreMessage('Maximum hours', 'minimum hours')
            }
        };
    }

    if (newEntry.maximumHoursPerWeek && newEntry.maximumHoursPerWeek > MAX_HOURS) {
        newErrors = {
            ...newErrors,
            maximumHoursPerWeek: {
                error: true,
                message: getNumMaxMessage('Maximum hours', MAX_HOURS)
            }
        };
    } else if (newEntry.minimumHoursPerWeek && !newEntry.maximumHoursPerWeek) {
        newErrors = {
            ...newErrors,
            maximumHoursPerWeek: {
                error: true,
                message: getReqMessage('If minimum hours are entered, a maximum hours value')
            }
        };
    }

    if (
        newEntry.weekdayStartTime &&
        newEntry.weekdayEndTime &&
        newEntry.weekdayStartTime > newEntry.weekdayEndTime
    ) {
        newErrors = {
            ...newErrors,
            weekdayStartTime: {
                error: true,
                message: getDateMaxMessage('end time')
            },
            weekdayEndTime: {
                error: true,
                message: getDateMinMessage('start time')
            }
        };
    }

    if (
        newEntry.saturdayStartTime &&
        newEntry.saturdayEndTime &&
        newEntry.saturdayStartTime > newEntry.saturdayEndTime
    ) {
        newErrors = {
            ...newErrors,
            saturdayStartTime: {
                error: true,
                message: getDateMaxMessage('end time')
            },
            saturdayEndTime: {
                error: true,
                message: getDateMinMessage('start time')
            }
        };
    }

    if (
        newEntry.sundayStartTime &&
        newEntry.sundayEndTime &&
        newEntry.sundayStartTime > newEntry.sundayEndTime
    ) {
        newErrors = {
            ...newErrors,
            sundayStartTime: {
                error: true,
                message: getDateMaxMessage('end time')
            },
            sundayEndTime: {
                error: true,
                message: getDateMinMessage('start time')
            }
        };
    }

    if (Object.keys(newErrors).length < 1) newErrors = checkDiff(newEntry, initialState);

    return newErrors;
};
